import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import BridgecrewMappingForm from './BridgecrewMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function BridgecrewCredentialsForm(props, ref) {
    const fields = [{
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={BridgecrewMappingForm}
        />
    )
}

export default forwardRef(BridgecrewCredentialsForm);